module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBold.83aed21.woff2";